"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = exports.getLayerStyles = void 0;
var Styling_1 = require("../../Styling");
var getLayerStyles = function (props) {
    return {
        root: [
            {
                // Prioritize the Keytips above all other Layers
                zIndex: Styling_1.ZIndexes.KeytipLayer,
            },
        ],
    };
};
exports.getLayerStyles = getLayerStyles;
var getStyles = function (props) {
    return {
        innerContent: [
            {
                position: 'absolute',
                width: 0,
                height: 0,
                margin: 0,
                padding: 0,
                border: 0,
                overflow: 'hidden',
                visibility: 'hidden',
            },
        ],
    };
};
exports.getStyles = getStyles;
//# sourceMappingURL=KeytipLayer.styles.js.map